import { defineMessage } from 'services/localization';

export const messages = {
    nameColumnName: defineMessage('name'),
    nameColumnTitle: defineMessage('approval_request_full_n_ier_number_of_reference_1'),
    amountDueColumnName: defineMessage('amount_due'),
    amountDueColumnTitle: defineMessage('amount_due'),
    descriptionColumnName: defineMessage('description'),
    descriptionColumnTitle: defineMessage('description_attached_to_the_request'),
    templateIdColumnName: defineMessage('request_type'),
    templateIdColumnTitle: defineMessage('approval_workflow_name__tion_approval_workflows'),
    activeStepNameColumnName: defineMessage('active_step'),
    activeStepNameColumnTitle: defineMessage('indicates_on_which_stag_n_the_approval_workflow'),
    attachmentColumnName: defineMessage('files'),
    attachmentColumnTitle: defineMessage('files_attached_to_the_request'),
    resolutionColumnName: defineMessage('status_1'),
    resolutionColumnTitle: defineMessage('status_of_approval_requ_oved_rejected_cancelled'),
    fraudulentActivityColumnName: defineMessage('fraud_risk'),
    fraudulentActivityColumnTitle: defineMessage('this_field_indicates_if__decision_has_been_made'),
    creationDateColumnName: defineMessage('creation_date'),
    creationDateColumnTitle: defineMessage('when_approval_for_this___started_in_approvalmax'),
    dateColumnName: defineMessage('date'),
    dateColumnTitle: defineMessage('date'),
    resolutionDateColumnName: defineMessage('decision_date'),
    resolutionDateColumnTitle: defineMessage('when_the_approval_reque_s_been_finally_approved'),
    dueDateColumnName: defineMessage('due_date'),
    dueDateColumnTitle: defineMessage('document_due_date_as_sh_n_the_accounting_system'),
    shippingDateColumnName: defineMessage('shipping_date'),
    shippingDateColumnTitle: defineMessage('shipping_date'),
    deliveryDateColumnName: defineMessage('delivery_date'),
    deliveryDateColumnTitle: defineMessage('delivery_date_for_the_purchase_order'),
    qboPurchaseOrderStatusColumnName: defineMessage('purchase_order_status'),
    qboPurchaseOrderStatusColumnTitle: defineMessage('purchase_order_status'),
    paymentDateColumnName: defineMessage('planned_payment_date'),
    paymentDateColumnTitle: defineMessage('planned_payment_date_set_in_xero'),
    xeroBPPaymentDateColumnName: defineMessage('payment_date'),
    xeroBPPaymentDateColumnTitle: defineMessage('date_of_the_bank_transaction'),
    expectedDateColumnName: defineMessage('expected_date'),
    expectedDateColumnTitle: defineMessage('expected_date_as_defined_in_xero'),
    documentDateColumnName: defineMessage('date'),
    documentDateColumnTitle: defineMessage('document_date_as_shown_in_the_accounting_system'),
    resolutionTimeColumnName: defineMessage('how_long_decision_took'),
    resolutionTimeColumnTitle: defineMessage('how_long_it_took_to_pro_start_to_final_decision'),
    amountColumnName: defineMessage('gross_amount'),
    amountColumnTitle: defineMessage('gross_amount_of_the_req_m_base_company_currency'),
    xeroBPAmountColumnName: defineMessage('amount'),
    xeroBPAmountColumnTitle: defineMessage('total_amount_of_money_p_o_batch_payment_request'),
    airwallexBPAmountColumnName: defineMessage('total_amount'),
    airwallexBPAmountColumnTitle: defineMessage('total_amount_of_money_p_h_batch_payment_request'),
    XeroAirwallexBPPaymentStatusColumnName: defineMessage('payment_status'),
    XeroAirwallexBPPaymentStatusColumnTitle: defineMessage('payment_status'),
    amaxPayBatchAmountColumnName: defineMessage('total_amount'),
    amaxPayBatchAmountColumnTitle: defineMessage('total_amount_of_money_p_h_batch_payment_request_1'),
    amaxPayBatchPaymentStatusColumnName: defineMessage('payment_status'),
    amaxPayBatchPaymentStatusColumnTitle: defineMessage('payment_status'),
    amaxPayBatchPaymentStatusNone: defineMessage('none'),
    amaxPayBatchPaymentStatusAwaitingPayment: defineMessage('awaiting_payment'),
    amaxPayBatchPaymentStatusProcessing: defineMessage('processing'),
    amaxPayBatchPaymentStatusPartiallyPaid: defineMessage('partially_paid'),
    amaxPayBatchPaymentStatusPaid: defineMessage('paid'),
    amaxPayBatchPaymentStatusFailed: defineMessage('failed'),
    amaxPayBatchPaymentStatusCancelled: defineMessage('cancelled'),
    amaxPayBankAccountNamesColumnName: defineMessage('bank_account'),
    amaxPayBankAccountNamesColumnTitle: defineMessage('bank_account'),
    netAmountColumnName: defineMessage('net_amount'),
    netAmountColumnTitle: defineMessage('net_amount_of_the_reque_m_base_company_currency'),
    taxAmountColumnName: defineMessage('total_tax'),
    taxAmountColumnTitle: defineMessage('total_tax_of_the_reques_e_base_company_currency'),
    currencyColumnName: defineMessage('currency'),
    currencyColumnTitle: defineMessage('currency_in_which_the_request_has_been_created'),
    taxTypeColumnName: defineMessage('amounts_are_tax'),
    taxTypeColumnTitle: defineMessage('are_amounts_tax_inclusi__not_include_tax_at_all'),
    documentNumberColumnName: defineMessage('number'),
    documentNumberColumnTitle: defineMessage('number_of_the_financial_document'),
    requestersColumnName: defineMessage('requester'),
    requestersColumnTitle: defineMessage('who_was_the_originator__n_the_workflow_settings'),
    participantsApprovedColumnName: defineMessage('approved_by'),
    participantsApprovedColumnTitle: defineMessage('who_has_already_approved_the_request'),
    participantsRejectedColumnName: defineMessage('rejected_by'),
    participantsRejectedColumnTitle: defineMessage('who_has_rejected_the_request'),
    participantsNonRespondedColumnName: defineMessage('waiting_for'),
    participantsNonRespondedColumnTitle: defineMessage('who_is_supposed_to_make__approval_workflow_step'),
    contactColumnName: defineMessage('contact'),
    contactQBOColumnName: defineMessage('vendor'),
    contactColumnTitle: defineMessage('counterparty_for_the_fi__of_accounts_receivable'),
    customerColumnName: defineMessage('customer'),
    customerColumnTitle: defineMessage('customer'),
    qBooksPayeeCustomerColumnName: defineMessage('payee_customer'),
    qBooksPayeeCustomerColumnTitle: defineMessage('payee_customer'),
    qBooksPayeeEmployeeColumnName: defineMessage('payee_employee'),
    qBooksPayeeEmployeeColumnTitle: defineMessage('payee_employee'),
    qBooksPaymentAccountColumnName: defineMessage('payment_account'),
    qBooksPaymentAccountColumnTitle: defineMessage('payment_account'),
    qBooksPaymentTypeColumnName: defineMessage('payment_type'),
    qBooksPaymentTypeColumnTitle: defineMessage('payment_type'),
    qBooksPaymentMethodColumnName: defineMessage('payment_method'),
    qBooksPaymentMethodColumnTitle: defineMessage('payment_method'),
    qBooksTermsColumnName: defineMessage('terms'),
    qBooksTermsColumnTitle: defineMessage('terms'),
    referenceColumnName: defineMessage('reference'),
    referenceColumnTitle: defineMessage('reference_of_the_financial_document'),
    brandingColumnName: defineMessage('branding_theme'),
    brandingColumnTitle: defineMessage('which_document_design_t_or_the_document_in_xero'),
    sentToSupplierColumnName: defineMessage('sent_to_supplier'),
    sentToSupplierColumnTitle: defineMessage('whether_the_purchase_or_en_sent_to_the_supplier'),
    auditReportStatusColumnName: defineMessage('audit_report_1'),
    auditReportStatusColumnTitle: defineMessage('pdf_audit_report_that_h_generated_upon_approval'),
    locationColumnName: defineMessage('location'),
    locationColumnTitle: defineMessage('location'),
    lineItemClassesColumnName: defineMessage('classes'),
    lineItemClassesColumnTitle: defineMessage('class_used_in_line_item__line_item_should_match'),
    lineItemAccountsColumnName: defineMessage('account'),
    lineItemAccountsColumnTitle: defineMessage('account_used_in_line_it__line_item_should_match'),
    bankAccountsColumnName: defineMessage('bank_account_number'),
    bankAccountsColumnTitle: defineMessage('this_field_contains_num_s_used_for_the_payments'),
    qbooksLineItemAccountsColumnName: defineMessage('category'),
    qbooksLineItemAccountsColumnTitle: defineMessage('category_used_in_line_i__line_item_should_match'),
    purchaseOrderBalanceColumnName: defineMessage('po_balance'),
    purchaseOrderBalanceColumnTitle: defineMessage('amount_of_the_purchase__what_is_left_to_be_paid_1'),
    matchedPurchaseOrdersColumnName: defineMessage('matched_purchase_orders'),
    matchedPurchaseOrdersColumnTitle: defineMessage('purchase_orders_matched_with_the_bill'),
    matchedBillsColumnName: defineMessage('matched_bills'),
    matchedBillsColumnTitle: defineMessage('bills_matched_with_the_purchase_order'),
    matchedBillsBalanceName: defineMessage('bill_remaining_balance'),
    matchedBillsBalanceTitle: defineMessage('bill_remaining_balance'),
    sumOfAllocationsName: defineMessage('sum_of_all_allocations'),
    sumOfAllocationsTitle: defineMessage('sum_of_all_allocations'),
    isBilledColumnName: defineMessage('billed'),
    isBilledColumnTitle: defineMessage('indicates_if_the_purcha__in_approvalmax_or_xero'),
    isPaidColumnName: defineMessage('paid'),
    isPaidColumnTitle: defineMessage('indicates_if_a_bill_has_been_marked_as_paid'),
    fullyPaidDateColumnName: defineMessage('paid_date'),
    fullyPaidDateColumnTitle: defineMessage('paid_date'),
    retrospectivePurchaseOrderColumnName: defineMessage('is_retrospective_1'),
    retrospectivePurchaseOrderColumnTitle: defineMessage('this_field_shows_if_the_ed_prior_to_the_po_date'),
    lineItemTrackings1ColumnName: defineMessage('tracking_category_2'),
    lineItemTrackings1ColumnTitle: defineMessage('tracking_category_2'),
    lineItemTrackings2ColumnName: defineMessage('tracking_category_3'),
    lineItemTrackings2ColumnTitle: defineMessage('tracking_category_3'),
    contactNameColumnName: defineMessage('contact_name'),
    contactNameColumnTitle: defineMessage('the_contact_name_used_in_the_request'),
    taxNumberColumnName: defineMessage('tax_id_number'),
    taxNumberColumnTitle: defineMessage('the_tax_id_number_used_in_the_request'),
    bankAccountDetailsColumnName: defineMessage('bank_account_number'),
    bankAccountDetailsColumnTitle: defineMessage('the_bank_account_number_used_in_the_request'),
    salesTaxCodeColumnName: defineMessage('default_sales_tax'),
    salesTaxCodeColumnTitle: defineMessage('the_sales_tax_record_sp_t_sales_tax_for_contact'),
    purchaseTaxCodeColumnName: defineMessage('default_purchase_tax'),
    purchaseTaxCodeColumnTitle: defineMessage('the_purchase_tax_record_urchase_tax_for_contact'),
    vendorNameColumnName: defineMessage('vendor_name'),
    vendorNameColumnTitle: defineMessage('the_vendor_name_used_in_the_request'),
    businessNumberColumnName: defineMessage('business_id_no_social_security_number'),
    businessNumberColumnTitle: defineMessage('the_business_id_no_or_s__number_used_in_request'),
    netSuiteCurrencyColumnName: defineMessage('currency_full_name'),
    netSuiteCurrencyColumnTitle: defineMessage('currency_full_name'),
    netSuiteVendorColumnName: defineMessage('vendor'),
    netSuiteVendorColumnTitle: defineMessage('vendor'),
    netSuitePayeeColumnName: defineMessage('payee'),
    netSuitePayeeColumnTitle: defineMessage('payee'),
    netSuiteEmployeeColumnName: defineMessage('employee'),
    netSuiteDocumentStatusColumnName: defineMessage('netsuite_status'),
    netSuiteDocumentStatusColumnTitle: defineMessage('netsuite_status'),
    netSuiteEmployeeColumnTitle: defineMessage('employee'),
    netSuiteCustomerColumnName: defineMessage('customer'),
    netSuiteCustomerColumnTitle: defineMessage('customer'),
    netSuiteTermsColumnName: defineMessage('terms'),
    netSuiteTermsColumnTitle: defineMessage('terms'),
    netSuiteExpenseReportExternalStatusColumnName: defineMessage('external_status'),
    netSuiteExpenseReportExternalStatusColumnTitle: defineMessage('external_status'),
    dearSupplierColumnName: defineMessage('supplier'),
    dearSupplierColumnTitle: defineMessage('supplier'),
    payersColumnName: defineMessage('paid_by'),
    payersColumnTitle: defineMessage('paid_by'),
    grnColumnName: defineMessage('grn_status'),
    grnColumnTitle: defineMessage('grn_status'),
    grnNotReceived: defineMessage('not_received'),
    grnPartiallyReceived: defineMessage('partially_received'),
    grnFullyReceived: defineMessage('fully_received'),
    grnStatusDateColumnName: defineMessage('grn_status_date'),
    grnStatusDateColumnTitle: defineMessage('grn_status_date'),
    isAcceptedColumnName: defineMessage('customer_decision'),
    isAcceptedColumnTitle: defineMessage('customer_decision'),
    isAcceptedTrue: defineMessage('accepted'),
    isAcceptedFalse: defineMessage('declined'),
    customerDecisionDateColumnName: defineMessage('customer_decision_date'),
    customerDecisionDateColumnTitle: defineMessage('customer_decision_date'),
    isSentColumnName: defineMessage('sent_to_the_customer'),
    isSentColumnTitle: defineMessage('sent_to_the_customer'),
    narrationColumnName: defineMessage('narration'),
    narrationColumnTitle: defineMessage('narration'),
    totalCreditTaxColumnName: defineMessage('total_credit_tax'),
    totalCreditTaxColumnTitle: defineMessage('total_credit_tax'),
    totalDebitTaxColumnName: defineMessage('total_debit_tax'),
    totalDebitTaxColumnTitle: defineMessage('total_debit_tax'),
    showOnCashBasisReportsColumnName: defineMessage('show_journal_on_cash_basis_reports'),
    showOnCashBasisReportsColumnTitle: defineMessage('show_journal_on_cash_basis_reports'),
    outstandingColumnName: defineMessage('outstanding'),
    outstandingColumnTitle: defineMessage('outstanding'),
    sentDateColumnName: defineMessage('sent_date'),
    sentDateColumnTitle: defineMessage('sent_date'),
    yes: defineMessage('yes'),
    no: defineMessage('no'),
};

export const resolutionColumnMessages = {
    onReview: defineMessage('on_review'),
    onApproval: defineMessage('on_approval'),
    rejected: defineMessage('rejected'),
    approved: defineMessage('approved'),
    cancelled: defineMessage('cancelled'),
    onHold: defineMessage('on_hold'),
};

export const netSuiteDocumentStatusColumnMessages = {
    vendorBillUnknown: defineMessage('vendor_bill_unknown'),
    vendorBillPendingApproval: defineMessage('vendor_bill_pending_approval'),
    vendorBillRejected: defineMessage('vendor_bill_rejected'),
    vendorBillOpen: defineMessage('vendor_bill_open'),
    vendorBillPaidInFull: defineMessage('vendor_bill_paid_in_full'),
    vendorBillCancelled: defineMessage('vendor_bill_cancelled'),
    purchaseOrderUnknown: defineMessage('purchase_order_unknown'),
    purchaseOrderClosed: defineMessage('purchase_order_closed'),
    purchaseOrderFullyBilled: defineMessage('purchase_order_fully_billed'),
    purchaseOrderPartiallyReceived: defineMessage('purchase_order_partially_received'),
    purchaseOrderPendingBillingPartiallyReceived: defineMessage('purchase_order_pending_billing_partially_received'),
    purchaseOrderPendingBilling: defineMessage('purchase_order_pending_billing'),
    purchaseOrderPendingReceipt: defineMessage('purchase_order_pending_receipt'),
    purchaseOrderPendingSupervisorApproval: defineMessage('purchase_order_pending_supervisor_approval'),
    purchaseOrderRejectedBySupervisor: defineMessage('purchase_order_rejected_by_supervisor'),
    salesOrderUnknown: defineMessage('sales_order_unknown'),
    salesOrderPendingApproval: defineMessage('sales_order_pending_approval'),
    salesOrderPendingFulfillment: defineMessage('sales_order_pending_fulfillment'),
    salesOrderPartiallyFulfilled: defineMessage('sales_order_partially_fulfilled'),
    salesOrderPendingBilling: defineMessage('sales_order_pending_billing'),
    salesOrderPendingBillingPartFulfilled: defineMessage('sales_order_pending_billing_part_fulfilled'),
    salesOrderClosed: defineMessage('sales_order_closed'),
    salesOrderBilled: defineMessage('sales_order_billed'),
    salesOrderCancelled: defineMessage('sales_order_cancelled'),
    salesOrderUndefined: defineMessage('sales_order_undefined'),
    vraPendingReturn: defineMessage('vra_pending_return'),
    vraCancelled: defineMessage('vra_cancelled'),
    vraClosed: defineMessage('vra_closed'),
    vraCredited: defineMessage('vra_credited'),
    vraPartiallyReturned: defineMessage('vra_partially_returned'),
    vraPendingApproval: defineMessage('vra_pending_approval'),
    vraPendingCredit: defineMessage('vra_pending_credit'),
    vraPendingCreditPartiallyReturned: defineMessage('vra_pending_credit_partially_returned'),
    vraUndefined: defineMessage('vra_undefined'),
    journalEntryPendingApproval: defineMessage('journal_entry_pending_approval'),
    journalEntryRejected: defineMessage('journal_entry_rejected'),
    journalEntryVoided: defineMessage('journal_entry_voided'),
    journalEntryApproved: defineMessage('journal_entry_approved'),
    journalEntryUndefined: defineMessage('journal_entry_undefined'),
    invoiceUndefined: defineMessage('invoice_undefined'),
    invoiceOpen: defineMessage('invoice_open'),
    invoicePaidInFull: defineMessage('invoice_paid_in_full'),
    invoicePendingApproval: defineMessage('invoice_pending_approval'),
    invoiceVoided: defineMessage('invoice_voided'),
    invoiceRejected: defineMessage('invoice_rejected'),
    expenseReportUnknown: defineMessage('expense_report_unknown'),
    expenseReportApprovedByAccounting: defineMessage('expense_report_approved_by_accounting'),
    expenseReportApprovedOverriddenByAccounting: defineMessage('expense_report_approved_overridden_by_accounting'),
    expenseReportInProgress: defineMessage('expense_report_in_progress'),
    expenseReportInTransit: defineMessage('expense_report_in_transit'),
    expenseReportPaidInFull: defineMessage('expense_report_paid_in_full'),
    expenseReportPendingAccountingApproval: defineMessage('expense_report_pending_accounting_approval'),
    expenseReportPendingSupervisorApproval: defineMessage('expense_report_pending_supervisor_approval'),
    expenseReportRejectedByAccounting: defineMessage('expense_report_rejected_by_accounting'),
    expenseReportRejectedBySupervisor: defineMessage('expense_report_rejected_by_supervisor'),
    expenseReportRejectedOverriddenByAccounting: defineMessage('expense_report_rejected_overridden_by_accounting'),
    expenseReportVoided: defineMessage('expense_report_voided'),
    billPaymentUnknown: defineMessage('bill_payment_unknown'),
    billPaymentApproved: defineMessage('bill_payment_approved'),
    billPaymentConfirmed: defineMessage('bill_payment_confirmed'),
    billPaymentDeclined: defineMessage('bill_payment_declined'),
    billPaymentInTransit: defineMessage('bill_payment_in_transit'),
    billPaymentOnlineBillPayPendingAccountingApproval: defineMessage('bill_payment_online_bil_ing_accounting_approval'),
    billPaymentPendingApproval: defineMessage('bill_payment_pending_approval'),
    billPaymentRejected: defineMessage('bill_payment_rejected'),
    billPaymentVoided: defineMessage('bill_payment_voided'),
};

export const fraudulentActivityColumnMessages = {
    None: defineMessage('no_fraud_detected'),
    AdminEnforcedResolving: defineMessage('forced_by_administrator'),
    AutomaticResolving: defineMessage('auto_approved'),
    DroppingOffApprovers: defineMessage('some_approvers_were_removed'),
    ExternalResolving: defineMessage('approved_directly_in_integrationname'),
    PostApprovalChange: defineMessage('changes_made_in_integrationname_after_approval'),
    ExternalResolvingNetSuite: defineMessage('resolved_directly_in_netsuite'),
};

export const outstandingColumnMessages = {
    daysOverdue: defineMessage('days_days_overdue'),
    daysUntilDue: defineMessage('days_days_until_due'),
};

export const taxTypeColumnMessages = {
    taxExclusive: defineMessage('tax_exclusive'),
    taxInclusive: defineMessage('tax_inclusive'),
    noTax: defineMessage('no_tax'),
};

export const auditReportStatusColumnMessages = {
    auditReportStatusColumnValueTextReady: defineMessage('ready'),
    auditReportStatusColumnValueTextUnderway: defineMessage('being_prepared'),
};

export const lineItemCustomersColumnMessages = {
    columnName: defineMessage('customers'),
    columnTitle: defineMessage('customers_used_in_line___line_item_should_match'),
};

export const matchedPOColumnMessages = {
    matched: defineMessage('matched'),
    notMatched: defineMessage('not_matched'),
};

export const matchedBillsColumnMessages = {
    matched: defineMessage('matched'),
    notMatched: defineMessage('not_matched'),
};

export const retrospectivePOMessages = {
    retrospective: defineMessage('is_retrospective_1'),
    notRetrospective: defineMessage('is_not_retrospective'),
};

export const qboPOStatusMessages = {
    qboPurchaseOrderStatusOptionOpen: defineMessage('open'),
    qboPurchaseOrderStatusOptionClosed: defineMessage('closed'),
};

export const netSuiteMessages = {
    externalStatusUnknown: defineMessage('unknown'),
    externalStatusApprovedByAccounting: defineMessage('approved_by_accounting'),
    externalStatusApprovedOverriddenByAccounting: defineMessage('approved_overridden_by_accounting'),
    externalStatusInProgress: defineMessage('in_progress'),
    externalStatusInTransit: defineMessage('in_transit'),
    externalStatusPaidInFull: defineMessage('paid_in_full'),
    externalStatusPendingAccountingApproval: defineMessage('pending_accounting_approval'),
    externalStatusPendingSupervisorApproval: defineMessage('pending_supervisor_approval'),
    externalStatusRejectedByAccounting: defineMessage('rejected_by_accounting'),
    externalStatusRejectedBySupervisor: defineMessage('rejected_by_supervisor'),
    externalStatusRejectedOverriddenByAccounting: defineMessage('rejected_overridden_by_accounting'),
    externalStatusVoided: defineMessage('voided'),
};
